import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ProductsProvider } from './contexts/ProductsContext';
import { SettingsProvider } from './contexts/SettingsContext';
import ApiTokenProvider from './components/ApiTokenProvider';
import { routes } from './router';
import Layout from './components/layout/Layout';
import OidcCallback from './components/OidcCallback';
import LogoutCallback from './components/LogoutCallback';

function App() {
  return (
    <BrowserRouter>
      {/*
        AuthProvider de react-oidc-context está en index.tsx
        Este AuthProvider es un wrapper que adapta OIDC a nuestra interfaz
      */}
      <AuthProvider>
          <ProductsProvider>
            <ApiTokenProvider>
              <SettingsProvider>
              <ThemeProvider>
                <LanguageProvider>
                  <NotificationProvider>
                  <Routes>
              {/* Ruta para el callback de OIDC */}
              <Route path="/callback" element={<OidcCallback />} />
              {/* Ruta para el callback de logout */}
              <Route path="/logout-callback" element={<LogoutCallback />} />
              {routes.map((route) => {
                if (!route.protected) {
                  return (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  );
                }

                return (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={<Layout>{route.element}</Layout>}
                  />
                );
              })}
            </Routes>
                  </NotificationProvider>
                </LanguageProvider>
              </ThemeProvider>
              </SettingsProvider>
            </ApiTokenProvider>
          </ProductsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;